// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__g2Fer","sidebarContent":"Sidebar_sidebarContent__BTG9k","box":"Sidebar_box__NcswJ"};